export default __webpack_public_path__ + "static/media/226.7758a186.jpg";